import React from 'react';
import { isMacOS } from '@/helpers';
import MacOSIcon from '@/icons/shortcuts/macos/increment-value-icon.inline.svg';
import WindowsOSIcon from '@/icons/shortcuts/windows/increment-value-icon.inline.svg';

const IncrementValueIcon = () => {
  const macOS = isMacOS();

  if (macOS) {
    return <MacOSIcon />;
  }
  return <WindowsOSIcon />;
};

export default IncrementValueIcon;
